// EQG-MOB-04 §3 — offline defect queue. Submitting with no signal is a success:
// the record is stored locally and flushed when connectivity returns.
import { mobileApi } from './api';

const QUEUE_KEY = 'mobile_defect_queue';
const EVENT = 'defectqueuechange';

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch {
    return [];
  }
};

const write = (list) => {
  localStorage.setItem(QUEUE_KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVENT));
};

export const queueCount = () => read().length;

export const enqueueDefect = (payload) => {
  const list = read();
  list.push({ id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`, payload, queued_at: new Date().toISOString() });
  write(list);
  return list.length;
};

let flushing = false;
export const flushQueue = async (token) => {
  if (flushing || !navigator.onLine) return;
  const list = read();
  if (list.length === 0) return;
  flushing = true;
  const remaining = [];
  for (const item of list) {
    try {
      await mobileApi.reportDefect(item.payload, token);
    } catch (e) {
      remaining.push(item); // keep it for the next attempt
    }
  }
  write(remaining);
  flushing = false;
};

export const onQueueChange = (cb) => {
  window.addEventListener(EVENT, cb);
  return () => window.removeEventListener(EVENT, cb);
};
